export const SOON_THRESHOLD_MINUTES = 30
export const ZOOM_OPEN_THRESHOLD_MINUTES = 15
export const NO_SHOW_THRESHOLD_MINUTES = -15
export const NO_SHOW_WARN_THRESHOLD_MINUTES = -10

export const ZOOM_CLOSED_TOOLTIP = `The Zoom room will open ${ZOOM_OPEN_THRESHOLD_MINUTES} minutes before the start of this session. Hang tight!`
